import { cx } from '@/lib/format';

/** The original transparent stacked artwork: whale with `orca` below it. */
export function BrandLockup({ className, decorative = false }: { className?: string; decorative?: boolean }) {
  return (
    <span className={cx('orca-lockup', className)} aria-hidden={decorative || undefined}>
      <img src="/assets/brand/orca-logo.png" alt={decorative ? '' : 'Orca'} width={445} height={464} />
    </span>
  );
}
